"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("@ledgerhq/errors");
/**
 * Specify a new name for a device. This is technically supported on all models
 * but only allowed on LNX and Stax currently. There are some FW version based
 * limitations on the max length to account for but these are enforced at the
 * command user level.
 */
exports.default = (transport, name) => __awaiter(void 0, void 0, void 0, function* () {
    yield transport.send(0xe0, 0xd4, 0x00, 0x00, Buffer.from(name)).catch(e => {
        if (e.statusCode === errors_1.StatusCodes.CONDITIONS_OF_USE_NOT_SATISFIED ||
            e.statusCode === errors_1.StatusCodes.USER_REFUSED_ON_DEVICE) {
            throw new errors_1.UserRefusedDeviceNameChange();
        }
        throw e;
    });
});
//# sourceMappingURL=editDeviceName.js.map